import { z } from "zod"

/** Validated `/interior-packages` search params (table state in the URL). */
export const interiorPackagesSearchSchema = z.object({
	q: z.preprocess(
		(val) => (val === "" || val === null || val === undefined ? undefined : val),
		z.string().min(1).max(200).optional(),
	),
	limit: z.coerce.number().int().min(1).max(200).default(25),
	offset: z.coerce.number().int().min(0).default(0),
	// Alphabetical so an edited package stays put instead of jumping to the top (Nic).
	sort: z.string().default("name.asc"),
})

export type InteriorPackagesSearch = z.infer<typeof interiorPackagesSearchSchema>

/** Use for `Link` / `redirect` to `/interior-packages` so validated search params are satisfied. */
export const defaultInteriorPackagesSearch: InteriorPackagesSearch = interiorPackagesSearchSchema.parse({})
